import { types } from 'mobx-state-tree';

export const CriteriaResultModel = types.model('CriteriaResultModel', {
    label: types.identifier,
    matched: types.boolean
});
